export const MenuListArray2 = [
    {
        title: 'nav.aboutUs',
        to: '/about-us',
    },

    {
        title: 'nav.team',
        to: '/team',
    },
    {
        title: 'nav.weightCalculator',
        to: '/weight-calculator',
    },


    {
        title: 'nav.services',
        to: '/services-details',
    },
    {
        title: 'nav.blog',
        to: '/wellness-journal',
    },
    {
        title: 'nav.contactUs',
        to: '/contact-us',
    },
]